export default {
  public: {
    loading: " Chargement...",
    ok: "OK",
    cancel: "Annuler",
    back: " Retour ",
    userDefined: "Personnalisé",
    edit: "Modifier",
    clear: "Effacer",
    delete: "Supprimer",
    close: "Fermer",
    remove: "Retirer",
    preView: "Aperçu",
    replace: "Remplacer",
    systemMsg: "Information",
    generateSuccess:
      "Votre présentation PowerPoint a été générée avec succès !",
    templateChoose:
      "Choisissez un modèle pour réaliser votre propre création d’IA",
    templateChooseShort: "Choisissez un modèle",
    templateChangeTips:
      "Remplacer les données du modèle les restaurera à leur contenu d’origine. Le contenu modifié sera perdu. Êtes-vous sûr de vouloir continuer?",
    sourceInvalid: "La source de données n’est pas valide, veuillez réessayer.",
    systemBusy: "Le serveur est occupé, veuillez rafraîchir la page",
    templateReplaceSuccess:
      "Le remplacement du modèle a été effectué avec succès. Veuillez enregistrer manuellement, car le système ne le fera pas automatiquement.",
    shareLinkTips: "Copié avec succès！Page de redirection pour vous",
    noPermissionTips:
      "Désolé, l'autorisation de partage de ce ppt a été fermée par l'auteur ~ Vous pouvez vous connecter à aippttv, montrer votre imagination et créer votre propre ppt !",
    copyTips: "Copié avec succès！",
    loginTips: "s’il vous plait Connectez-vous d’abord！",
    bottomTag: "Fait avec {brand}",
    fontType: {
      Arial: "Arial",
      "Microsoft Yahei": "Microsoft YaHei",
      SimSun: "SimSun",
      SimHei: "SimHei",
      KaiTi: "KaiTi",
      NSimSun: "NSimSun",
      FangSong: "FangSong",
      "PingFang SC": "PingFang",
      STHeiti: "STHeiti",
      STKaiti: "STKaiti",
      STSong: "STSong",
      STFangSong: "STFangsong",
      STZhongSong: "STZhongsong",
      STHupo: "STHupo",
      STXinwei: "STXinwei",
      STLiti: "STLiti",
      STXingkai: "STXingkai",
      "Hiragino Sans GB": "Hiragino Sans",
      "Lantinghei SC": "Lantinghei",
      "Hanzipen SC": "Pianpian",
      "Hannotate SC": "Shouzhati",
      "Songti SC": "Songti",
      "Wawati SC": "Wawati",
      "Xingkai SC": "Xingkai",
      "Yuanti SC": "Yuanti",
      STXihei: "STXihei",
      YouYuan: "Youyuan",
      LiSu: "Lishu",
    },
    font: {
      font: "Police",
      sysFont: "Police systèm",
      lineFont: "Police en ligne",
      fontColor: "Couleur du texte",
      textColor: "Couleur de police",
      fontDelay: "Surbrillance de la police",
      addSize: "Augmenter la taille",
      duceSize: "Diminuer la taille",
      left: "Aligner à gauche",
      middle: "Centrer",
      horizontalCenter: "Centrage Horizontal",
      verticalCenter: "Centrage Vertical",
      right: "Aligner à droite",
      bottom: "Aligner en bas",
      top: "Aligner en haut",
      bold: "Gras",
      em: "Italique",
      underline: " Souligné",
      strikethrough: "Barré",
      richText: "Supprimer Le Formatage",
      textFormat: "Pinceau de mise en forme",
      addIndex: "Diminuer le retrait",
      duceIndex: "Augmenter le retrait",
      no: "Numérotation",
      link: "Lien hypertexte",
      inputLink: "Insérer lien",
      superscript: "Exposant ",
      subscript: "Indice",
      code: "Code en ligne",
      blockquote: "Citation",
      horizontal: "Horizontal",
      vertical: "Vertical",
      width: "Largeur",
      height: "Hauteur",
      rotate: "Rotation",
      uniformHorizontal: "Distribuer horizontalement",
      uniformVertical: "Distribuer verticalement",
      combine: "Combiner",
      unCombine: "Dissocier",
      bgColor: "Couleur de fond",
      mainColor: "Couleur du thème",
      useMainToAll: "Appliquer le thème à tous",
      preMain: "Thème prédéfini",
    },
    specialEffects: {
      useAll: "Appliquer à tous",
      no: "Aucun",
      fade: "Fondu en/sortant",
      slideX: "Glisser à gauche/droite",
      slideY: "Glisser vers le haut/vers le bas",
    },
  },
  chart: {
    insertCol: "Insérer une colonne",
    insertRow: "Insérer une ligne",
    delCol: "Supprimer la colonne",
    delRow: "Supprimer la ligne",
    merCell: "Fusionner les cellules",
    unMerCell: "Séparer les cellules",
    selectCurrentCol: "Sélectionner la colonne actuelle",
    selectCurrentRow: "Sélectionner la ligne actuelle",
    selectAll: "Sélectionner toutes les cellules",
    toTheLeft: "À gauche",
    toTheRight: "À droite",
    toTheTop: "En haut",
    toTheBottom: "En bas",
  }, 
  desktop: {
    fileExportSuccess:
      "El archivo se ha exportado correctamente. Seleccione una ubicación para guardar el archivo’, translate french: ‘Le fichier a été exporté avec succès. Sélectionnez un emplacement pour enregistrer le fichier",
    unSupportPreviewPDF:
      "L'aperçu PDF n'est pas disponible ici. Si vous souhaitez un aperçu, veuillez vous rendre sur le site officiel du PC.",
  },
  extension: {
    nonsupportDownloadPDF:
      "Le plug-in de navigateur ne prend pas en charge le téléchargement de PDF, veuillez vous rendre sur le site officiel pour télécharger",
  },
  index: {
    createText: "Générer du contenu PPT",
    createPage: "Générer du contenu pour la page {0}",
    haveProblem: "J’ai un problème",
    systemError: "{0}",
    saveText: "Enregistré avec succès",
    saveMessage: "Êtes-vous sûr de vouloir enregistrer ?",
    cBtn: "Annuler",
    sBtn: "OK",
    waitMsg:
      "Veuillez patienter et attendre 30 à 40 secondes. Si cela ne se génère pas, veuillez rafraîchir votre navigateur et réessayer !",
  },
  errorCode: {
    401: "Échec de l’authentification, impossible d’accéder aux ressources système",
    403: "L’exploitation en cours n’est pas autorisée",
    404: "Ressource introuvable",
    default: "Erreur système inconnue, veuillez la signaler à l’administrateur",
    notReDo:
      "Les données sont en cours de traitement, veuillez ne pas les renvoyer.",
    loginMsg: "Session invalide ou session expirée. Veuillez vous reconnecter.",
    errMsg: "Le système est occupé, veuillez réessayer plus tard.",
  },
  linkHandler: {
    pptPage: "Diapositive",
    change: "Changer",
    remove: "Supprimer",
  },
  editor: {
    ctrlV: "Pâte",
    ctrlA: "Tout sélectionner",
    enter: "Nouvelle page",
    f5: "Diaporama",
    delete: "Supprimer la page",
    ctrlD: "Dupliquer la page",
    ctrlX: "Couper",
    ctrlC: "Copie",
    shiftF5: "Commencer par le courant",
    positionPanel: {
      horizontalCenter: "Centrer horizontalement",
      verticalCenter: "Centrer verticalement",
      horizontalVerticalCenter: "Centrer horizontalement et verticalement",
      left: "Aligner à gauche",
      right: "Aligner à droite",
      top: "Aligner en haut",
      bottom: "Aligner en bas",
      onTop: "Mettre au-dessus",
      onBottom: "Mettre en dessous",
      levelUp: "Monter d'un niveau",
      levelDown: "Descendre d'un niveau",
      setLink: "Définir le lien",
      ungroup: "Dégrouper",
      group: "Grouper",
      selectAll: "Tout sélectionner",
      lock: "Verrouiller",
      unlock: "Débloquer",
      delete: "Supprimer",
    },
    canvas: {
      index: {
        ctrlR: "Règle",
        ctrlW: "Lignes de grille",
        nl: "Aucun",
        small: "Petit",
        middle: "Moyen",
        big: "Grand",
        closePan: "Fermer le panneau de sélection",
        openPan: "Ouvrir le panneau de sélection",
        reCurrentPage: "Réinitialiser la page actuelle",
        showPpt: "Diaporama",
        generate:'Générant...'
      },
      linkDialog: {
        url: "Veuillez saisir l’adresse du lien Web",
        ppt: "Diapositive",
        preView: "Aperçu",
        pageUrl: "Lien Web",
        pptPage: "Page de diapositive",
      },
    },
    canvasTool: {
      index: {
        ctrlZ: "Défaire",
        reSet: "Refaire",
        text: "Insérer le texte",
        horizontal: "Boîte de texte horizontale",
        vertical: "Boîte de texte verticale",
        image: "Insérer l’image",
        shape: "Insérer une forme",
        line: "Insérer des ligne",
        chart: "Insérer le graphique",
        table: "Insérer un tableau",
        gs: " Insérer une formule ",
        voice: "Insérer un vidéo / l’audio",
        screen: "Ajuster à l’écran",
        workspase: "Espace de travail",
        save: "Sauvegarder",
        logo: "Insérer le logo",
        close: "Fermer le PPT",
        download: "Télécharger",
        share: "Partager",
        templateReplacement: "Remplacement de modèle",
      },
      mediaInput: {
        videoUrl: "Entrez l’URL de la vidéo, par ex.https://xxx.mp4",
        voiceUrl: "Entrez l’URL de l’audio, par exemple https://xxx.mp3",
        video: "Vidéo",
        voice: "Audio",
        videoError: "Veuillez d’abord entrer une URL vidéo correcte.",
        voiceError: "Veuillez d’abord entrer une URL audio correcte",
      },
      tableGenerator: {
        table: "Tableau",
        row: "Lignes",
        column: "Colonnes",
        rcError:
          "Le nombre de lignes/colonnes doit être compris entre 0 et 20 !",
      },
      logo: {
        text1: "Télécharger le logo de l’entreprise",
        text2: "Entrez le nom de l’entreprise",
        companyNamePlaceholder: "Entrez le nom de votre société",
        single: "Appliquer à une seule page",
        all: "Appliquer à toutes",
        position: "position",
      },
    },
    editorHeader: {
      index: {
        file: "Fichier",
        importPptistFile: "Importer un fichier pptist",
        importPptxFile: "Importer un fichier pptx",
        exportPptxFile: "Exporter le fichier",
        undo: "Défaire",
        redo: "Refaire",
        createSlide: "Ajouter une page",
        deleteSlide: "Supprimer la page",
        closeGridLines: "Fermer la grille",
        openGridLines: "Ouvrir la grille",
        closeRuler: "Fermer la règle",
        openRuler: "Ouvrir la règle",
        resetSlides: "Réinitialiser les diapositives",
        closeSelectPanel: "Fermer Sélection",
        openSelectPanel: "Ouvrir Sélection",
        f5: "Présenter",
        enterScreeningFromStart: "Commencer depuis le début",
        enterScreening: "Commencer depuis la page actuelle",
        help: "Aide",
        hotkey: "Raccourcis",
        pptShow: "Diaporama",
        export: "Exporter",
        importing: "Importation en cours.",
        continue: "Continuer",
        pauseGeneration: "Pause",
        noPricing:
          "Devenez membre et profitez des privilèges de téléchargement avec nous.",
        noPricingToOpt: "Débloquer tous les privilèges.",
        getTokens: "Passer à Pro",
        pptSlidesMsg:
          "Félicitations pour la création de {0} diapositives de PPT complètes !",
        Feedback: "Laissez l’IA être votre assistant de travail.",
        giveAway: "Offrez des coupons (valables pendant 30 minutes)",
        getItNow: "Obtenez-le maintenant",
        unlockAllPpt: "Débloquer toutes les fonctionnalités de PPT",
        grantPermission:
          "Accorder la permission d’utiliser la carte mentale IA",
        grantPermissionToUseGpt: "Accorder la permission d’utiliser GPT",
        permissionCodeUse:
          "Veuillez vous souvenir du code de réduction et passer à la page de paiement pour l’utiliser!",
        pptTi1:
          "Vous avez terminé tout le travail et généré un total de {0} pages de diapositives.",
        pptTi2:
          "Il ne vous reste que la dernière étape pour obtenir votre merveilleuse création IA !",
      },
    },
    exportDialog: {
      tips:'Le téléchargement PPT n\'est pas pris en charge dans l\'application pour le moment ; veuillez télécharger sur le PC',
      exportScope: "Étendue d’exportation",
      close: "Fermer",
      all: "Tout",
      thisPage: "Actuel",
      auto: "Personnalisée",
      autoScope: "Plage personnalisée",
      exporting: "Exportation en cours...",
      exportImg: "Exporter l’image",
      expPdf: "Imprimer/Exporter le PDF",
      expPptx: "Exporter en PPTX",
      downloadSuccess:
        "Conversion de fichier réussie. Veuillez sélectionner un chemin de sauvegarde",
      exportImage: {
        exportType: "Format d’exportation",
        imageQuality: "Qualité d’image",
        ignoreFont: "Ne pas utiliser les polices en ligne",
        ignoreLineFont:
          "Par défaut, les polices en ligne seront ignorées lors de l’exportation.Si vous avez utilisé des polices en ligne dans la présentation et que vous souhaitez conserver leurs styles après l’exportation, vous pouvez choisir de désactiver l’option « Ignorer les polices en ligne », mais veuillez noter que cela peut augmenter la durée de l’exportation.",
      },
      exportPdf: {
        all: "Tout",
        thisPage: "Actuel",
        pageNum: "Page par feuille",
        white: "Marge",
        notice:
          'Note : Si l’aperçu d’impression ne correspond pas au style réel, veuillez vérifier l’option "Graphiques d’arrière-plan" dans la fenêtre d’impression contextuelle.',
      },
      exportPPTX: {
        title: "Remplacer le modèle par défaut",
        notice:
          "Note: Après le téléchargement, veuillez l’ouvrir avec Microsoft Office, car d’autres peuvent ne pas être compatibles.",
      },
    },
    remark: {
      remark: "Cliquez pour entrer les notes du présentateur",
    },
    thumbnails: {
      add: " Ajouter une diapositive ",
      slide: " Diapositive ",
    },
    toolbar: {
      common: {
        elementColorMask: {
          recolor: " Recolorer (Masque)",
          maskColor: "Couleur de masque",
          opacity: "Opacité",
        },
        elementFilter: {
          enableFilter: "Activer les filtres",
          blur: "Flou",
          brightness: "Luminosité",
          contrast: "Contraste",
          grayscale: "Niveaux de gris",
          saturate: "Saturation",
          hueRotate: "Rotation de teinte",
          opacity: "Opacité",
        },
        elementFlip: {
          horizontal: "Retourner horizontalement",
          vertical: "Retourner verticalement",
        },
        elementOpacity: {
          opacity: "Opacité",
        },
        elementOutline: {
          border: "Activer la bordure",
          borderStyle: "Style de bordure",
          solid: "Bordure solide",
          dashes: "Bordure en pointillés",
          borderColor: "Couleur bordure",
          borderWeight: "Poids bordure",
        },
        elementShadow: {
          enable: "Activer l’ombre",
          horizontal: "Ombre horizontale",
          vertical: "Ombre verticale",
          fuzzyDistance: "Distance de flou",
          color: "Couleur de l’ombre",
        },
      },
      panel: {
        background: "Remplissage d’arrière - plan",
        solid: "Remplissage de couleur unie",
        image: "Remplissage d’image",
        gradient: "Remplissage dégradé",
        contain: "Ajuster",
        repeat: "Titre",
        cover: "Ajuster pour remplir",
        linear: "Dégradé linéaire",
        radial: "Dégradé radial",
        startColor: "Couleur de départ",
        endColor: "Couleur de fin",
        rotate: "Angle du dégradé",
        useBackgroundToAll: "Appliquer l’arrière - plan à tous",
      },
      elementStylePanel: {
        chartStylePanel: {
          chartDataEditor: {
            rowType: "Catégorie",
            colType: "Série",
          },
          index: {
            edit: "Modifier données",
            area: "Style de l’aire",
            line: "Style de dispersion",
            lineSmooth: "Utiliser une ligne lisse",
            horizontalBars: "Style de barres",
            stackBars: "Style empilé",
            donut: "Style de donut",
            img: "Légende",
            hidden: "Cacher",
            showTop: "Afficher en haut",
            showBottom: "Afficher en bas",
            tabColor: "Couleur grille",
            labelColor: "Couleur de la police",
            titleSetColor: " Couleur du thème:",
            title: "Thèmes recommandés",
            titleColor: "Ajouter couleur thème",
          },
        },
        audioStylePanel: {
          imgColor: "Couleur de l’icône",
          autoPlay: "Lecture automatique",
          loopPlay: "Lecture en boucle",
        },
        imageStylePanel: {
          cutImg: "Recadrer l’image",
          shape: "Par forme",
          type: "Catégorie",
          preview: "Aperçu",
          use: "Utiliser",
          searchByType: "Recherche par catégorie",
          uploadAndReplace: "Télécharger et remplacer l’image",
          reSetStyle: "Réinitialiser le style",
          setBackground: "Définir comme arrière-plan",
          clip1: "Par rapport d’aspect(Carré)",
          clip2: "Par rapport d’aspect(Portrait)",
          clip3: "Par rapport d’aspect(Paysage)",
        },
        latexStylePanel: {
          edit: "Modifier LaTeX",
          color: "Couleur",
          bold: "Gras",
        },
        lineStylePanel: {
          style: "Style de ligne",
          solid: "Ligne pleine",
          dotted: "Ligne en pointillés",
          color: "Couleur de la ligne",
          weight: "Largeur de ligne",
          startStyle: "Style de départ",
          endStyle: "Style de fin",
          none: "Aucun",
          arrow: "Flèche",
          dot: "Point",
        },
        multiStylePanel: {
          colorPicker: "Couleur de remplissage",
          style: "Style de bordure",
          solid: "Bordure pleine",
          dotted: "Bordure pointillés",
          color: "Couleur bordure",
          weight: "Largeur bordure",
        },
        shapeStylePanel: {
          replaceShade: "Remplacer la forme",
          fill: "Remplissage solide",
          gradient: "Dégradé de remplissage",
          linear: "Dégradé linéaire",
          radial: "Dégradé radial",
        },
        tableStylePanel: {
          colFull: "Remplissage de cellule",
          row: "Rangées",
          col: "Colonnes",
          titleRow: "Ligne de titre",
          totalRow: "Ligne totale",
          firstCol: "Première colonne",
          lastCol: "Dernière colonne",
          titleColor: "Couleur du thème",
          themeTable: "Tableau de thème",
        },
        textStylePanel: {
          urlError: "Adresse de lien web incorrecte",
          command: "Liste à puces",
          lineHeight: "Interligne",
          times: "Multiples",
          paragraphSpace: "Espacement paragraphe",
          wordSpace: "Espacement mots",
          textIndent: "Première ligne",
          textFill: "Remplissage texte",
          title: "Titre",
          titleSmall: "Sous-titre",
          text: "Texte",
          textSmall: "Texte[Petit]",
          zs1: "Note 1",
          zs2: "Note 2",
        },
        videoStylePanel: {
          cover: "Aperçu de la couverture vidéo",
          recover: "Réinitialiser la couverture",
        },
      },
      elementAnimationPanel: {
        addEffects: "Ajouter Animation",
        selectAndAddEffects:
          "Sélectionner les éléments sur le canevas et ajouter une animation ",
        time: "Durée",
        triggerType: "Type déclencheur",
        initiative: "Déclencheur d’initiative",
        sameTime: "Déclenchement simultané",
        after: "Après le précédent",
        change: "Modifier l’animation",
        in: "Améliorer",
        out: "Sortie",
        attention: "Accent",
      },
      elementPositionPanel: {
        layer: "Couche",
        align: "Aligner",
        top: "Placement en haut",
        bottom: "Placement en bas",
        up: "Avancer",
        down: "Reculer",
        noRixedRatio: "Déverrouiller le rapport hauteur/largeur",
        fixedRatio: "Verrouiller le rapport hauteur/largeur",
      },
      index: {
        style: "Style",
        symbol: "Symbole",
        position: "Position",
        animation: "Animation",
        design: "Design",
        slideAnimation: "Transitions",
      },
      slideDesignPanel: {
        canvasSize: "Taille du canevas",
        wideScreen1: "Écran large 16:9",
        wideScreen2: "Écran large 16:10",
        standard: "Standard 4:3",
        paper: "Papier A3/A4",
        title: "Thème global",
        mainColor: "Couleur du thème",
        useMainToAll: "Appliquer le thème à tous",
        preMain: "Thème prédéfini",
        text: "Texte Aa",
        use: "Appliquer",
        useToAll: "Appliquer à tous",
      },
    },
    selectPanel: {
      select: "Sélectionner",
      showAll: "Afficher tout",
      hideAll: "Masquer tout",
      group: "Regrouper",
    },
    redraw: {
      topLabel: "Regenerate",
      msgTips: "Veuillez saisir le contenu généré",
      retext: "Regenerate",
      cltext: "Annuler",
      btnText: "Créer",
      reConfirm:
        "Générer cela remplacera la page actuelle et ne sauvegardera pas le contenu historique. Êtes-vous sûr de vouloir continuer ?",
      confirmBtnTxt: "Continuer",
    },
  },
  screen: {
    presenter: {
      normalView: "Vue normale",
      pen: "Stylo",
      laserPointer: "Stylo laser",
      timer: "Minuteur",
      exitFullScreen: "Quitter plein écran",
      fullScreen: "Plein écran",
      endPresentation: "Fin de présentation",
      speakerNotes: "Notes du speaker ",
      speakersView: "Vue du speaker",
      previousPage: "Page précédente",
      nextPage: "Page suivante",
      firstPage: "Première page",
      lastPage: "Dernière page",
      brushTool: "Outil Pinceau",
      noRemarks: "Aucune remarque",
      lastPageTips: "Déjà la dernière page",
      firstPageTips: "Déjà la première page",
      autoPlay: "Démarrer le diaporama automatique",
    },
    writingBoard: {
      inkThickness: "Épaisseur de l’encre",
      eraserSize: "Taille gomme",
      eraser: "Gomme",
      clearInk: "Encre effaçable",
      blackboard: "Tableau noir",
      closeBrush: "Brosse fermée",
    },
  },
  mobile: {
    index: {
      notSupport: "La version mobile est en cours de développement en urgence.",
      toPc: "Veuillez visiter le site Web sur un ordinateur.",
      editTips: "Veuillez éditer sur l’ordinateur.",
    },
  },
  useCreateElement: {
    type: "Taper{0}",
    class: "Série{0}",
  },
  components: {
    latexEditor: {
      index: {
        lateX: "Entrer une formule LaTeX",
        preViw: "Aperçu de la formule",
        symbol: "Symboles courants",
        formula: "Formules prédéfinies",
        error: "La formule ne peut pas être vide",
      },
    },
    colorPicker: {
      recentUse: "Utilisation récente",
    },
  },
  config: {
    latex: {
      gauss: "Formule gaussienne",
      fourierSeries: "Série de Fourier",
      taylorExpansion: "Expansion de Taylor",
      definiteIntegral: "Intégrale définie",
      trigonometricIdentity1: "Identité trigonométrique 1",
      trigonometricIdentity2: "Identité trigonométrique 2",
      expansion: "Expansion de la somme",
      euler: "Formule d’Euler",
      differential: "Équation de Bernoulli",
      totalDifferentialEquation: "Équation différentielle totale",
      homogeneous: "Équation non homogène",
      cauchy: "Théorème de la valeur moyenne de Cauchy",
      lagrange: "Théorème de la valeur moyenne de Lagrange",
      arcsin: "Formule dérivée",
      trigonometric: "Intégration de fonctions trigonométriques",
      quadric: "Surface quadratique",
      dx: "Différentiel de second ordre",
      partial: "Dérivée directionnelle",
      operators: "Mathématiques",
      group: "Combinaisons",
      verbatim: "Fonction",
      greek: "Lettres grecques",
    },
    symbol: {
      letter: "lettre",
      number: "nombre",
      math: "mathématique",
      arrow: "flèche",
      graph: "graphique",
    },
    lines: {
      straight: "Droit",
      brokenOrCurve: "Cassé ou Courbé",
    },
  },
  hotkey: {
    opt: {
      common: "Universel",
      ctrlX: "Couper",
      ctrlC: "Copie",
      ctrlV: "Pâte",
      ctrlD: "Copier-coller rapide",
      ctrlA: "Tout sélectionner",
      ctrlZ: "Défaire",
      ctrlY: "Refaire",
      del: "Supprimer",
      ctrlMore: "Sélection multiple",
      ctrlP: "Imprimer",
      esc: "Fermer la fenêtre",
    },
    slide: {
      show: "Diaporama",
      edit: "Éditer diapo",
      first: "Montrer depuis le début",
      current: "Montrer du courant",
      spacePre: "Passer à la page précédente",
      spaceNext1: "Passer à la page suivante",
      spaceNext2: "Passer à la page suivante",
      out: "Quitter la présentation",
      new: "Nouvelle diapositive",
      move: "Déplacer le canevas",
      upOrDown: "Toile zoom",
      up: "Agrandir le canevas",
      down: "Réduire le canevas",
      screen: "Ajuster le canevas à l’écran",
      noSelectPrePage: "Page précédente (éléments non sélectionnés)",
      noSelectNextPage: "Page suivante (éléments non sélectionnés)",
      prePage: "Page précédente",
      nextPage: "Page suivante",
    },
    element: {
      opt: "Opérations éléments",
      move: "Déplacer",
      lock: "Verrouiller",
      combo: "Regrouper",
      cancelCombo: "Dissocier",
      top: "Mettre au premier plan",
      bottom: "Envoyer au fond",
      h: "Verrouiller le rapport hauteur/largeur",
      v: "Créer une ligne horizontale / verticale",
      change: "Changer l’élément de focus",
      com: "Confirmer le recadrage de l’image",
      text: "Texte",
      image: "image",
      shape: "forme",
      line: "ligne",
      chart: "graphique",
      table: "tableau",
      video: "vidéo",
      audio: "audio",
      latex: "Formule",
    },
    table: {
      edit: "Édition de tableau",
      nextCol: "Passer à la cellule suivante",
      insertTop: "Insérer une ligne au-dessus ",
      insertBottom: "Insérer une ligne en dessous",
      insertLeft: "Insérer une colonne à gauche",
      insertRight: "Insérer une colonne à droite",
    },
    chat: {
      edit: "Éditer données graphique",
      nextLine: "Focus sur la ligne suivante",
    },
    text: {
      edit: "Édition de texte",
      bold: "Gras",
      italics: "Italique",
      underline: "Souligner",
      delLine: "Barrer",
    },
  },
  shape: {
    rectangle: "Rectangle",
    commonUse: "Formes courantes",
    arrow: "Flèche",
    other: "Autres formes",
    line: "Ligne",
  },
  animation: {
    in: {
      bounce: "rebond",
      bounceIn: "rebond vers l’intérieur",
      bounceInLeft: "rebond à gauche",
      bounceInRight: "rebond à droite",
      bounceInUp: "rebond vers le haut",
      bounceInDown: "rebond vers le bas",
      fade: "fondu",
      fadeIn: "fondu en",
      fadeInDown: "fondu en bas",
      fadeInDownBig: "fondu en bas grand",
      fadeInLeft: "fondu en gauche",
      fadeInLeftBig: "fondu en gauche grand",
      fadeInRight: "fondu en droite",
      fadeInRightBig: "fondu en droite grand",
      fadeInUp: "fondu en haut",
      fadeInUpBig: "fondu en haut grand",
      fadeInTopLeft: "fondu en haut gauche",
      fadeInTopRight: "fondu en haut droite",
      fadeInBottomLeft: "fondu en bas gauche",
      fadeInBottomRight: "fondu en bas droite",
      rotate: "tourner",
      rotateIn: "tourner en",
      rotateInDownLeft: "tourner en bas à gauche",
      rotateInDownRight: "tourner en bas à droite",
      rotateInUpLeft: "tourner en haut à gauche",
      rotateInUpRight: "tourner en haut à droite",
      zoom: "zoom",
      zoomIn: "zoom en",
      zoomInDown: "zoom en bas",
      zoomInLeft: "zoom en gauche",
      zoomInRight: "zoom en droite",
      zoomInUp: "zoom en haut",
      slide: "glissement",
      slideInDown: "glissement en bas",
      slideInLeft: "glissement à gauche",
      slideInRight: "glissement à droite",
      slideInUp: "glissement en haut",
      flip: "rotation ",
      flipInX: "rotation intérieure en X",
      flipInY: "rotation intérieure en Y",
      back: "retour",
      backInDown: "retour en bas",
      backInLeft: "retour à gauche",
      backInRight: "retour à droite",
      backInUp: "retour en haut",
      lightSpeed: "vitesse lumière",
      lightSpeedInRight: "entrée en vitesse lumière à droite",
      lightSpeedInLeft: "entrée en vitesse lumière à gauche",
    },
    out: {
      bounce: "rebond",
      bounceOut: "rebond sortant",
      bounceOutLeft: "rebond sortant gauche",
      bounceOutRight: "rebond sortant droite",
      bounceOutUp: "rebond sortant haut",
      bounceOutDown: "rebond sortant bas",
      fade: "fondu",
      fadeOut: "fondu sortant",
      fadeOutDown: "fondu sortant bas",
      fadeOutDownBig: "fondu sortant bas grand",
      fadeOutLeft: "fondu sortant gauche",
      fadeOutLeftBig: "fondu sortant gauche grand",
      fadeOutRight: "fondu sortant droite",
      fadeOutRightBig: "fondu sortant droite grand",
      fadeOutUp: "fondu sortant haut",
      fadeOutUpBig: "fondu sortant haut grand",
      fadeOutTopLeft: "fondu sortant haut gauche",
      fadeOutTopRight: "fondu sortant haut droite",
      fadeOutBottomLeft: "fondu sortant haut droite",
      fadeOutBottomRight: "fondu sortant bas droite",
      rotate: "tourner",
      rotateOut: "tourner sortant",
      rotateOutDownLeft: "tourner sortant bas gauche",
      rotateOutDownRight: "tourner sortant bas droite",
      rotateOutUpLeft: "tourner sortant haut gauche",
      rotateOutUpRight: "tourner sortant haut droite",
      zoom: "zoom",
      zoomOut: "zoom arrière",
      zoomOutDown: "zoom arrière bas",
      zoomOutLeft: "zoom arrière gauche",
      zoomOutRight: "zoom arrière droite",
      zoomOutUp: "zoom arrière haut",
      slide: " glissement ",
      slideOutDown: "glissement sortant bas",
      slideOutLeft: "glissement sortant gauche",
      slideOutRight: "glissement sortant droite",
      slideOutUp: "glissement sortant haut",
      flip: "rotation",
      flipOutX: "rotation extérieure en X",
      flipOutY: "rotation extérieure en Y",
      back: "retour",
      backOutDown: "retour sortant bas",
      backOutLeft: "retour sortant gauche",
      backOutRight: "retour sortant droite",
      backOutUp: "retour sortant haut",
      lightSpeed: "vitesse lumière",
      lightSpeedOutRight: "sortie en vitesse lumière à droite",
      lightSpeedOutLeft: "sortie en vitesse lumière à gauche",
    },
    attention: {
      shake: "secousse",
      shakeX: "secousse X",
      shakeY: "secousse Y",
      headShake: "secousse de tête",
      swing: "balancement",
      wobble: "oscillation",
      tada: "tada",
      jello: "tremblotement",
      other: "autre",
      bounce: "rebondissement",
      flash: "éclair",
      pulse: "pulsation",
      rubberBand: "élastique",
      heartBeat: "battement de cœur",
    },
  },
  requestError: {
    tokenExpires:
      "L'authentification a échoué, impossible d'accéder aux ressources système.",
    permissionDenied: "L'opération en cours n'est pas autorisée.",
    notFound: "Ressource non trouvée.",
    default:
      "Erreur système inconnue, veuillez la signaler à l'administrateur.",
    exceptionReminder: "Rappel d'exception",
    pleaseLogin:
      "Session invalide ou la session a expiré, veuillez vous reconnecter.",
    networkError: "Erreur réseau",
    requestTimeOut:
      "Le délai d'attente de la requête d'interface système a expiré.",
    requestFailed: "La requête a échoué.",
  },
  promptsText: {
    theme: [
      "Explorez divers thèmes et savourez un plaisir infini !",
      "Cliquez sur chaque page thématique et embarquez pour un voyage enchanteur !",
      "Chaque thème possède son charme unique, pourquoi ne pas les explorer tous ? ",
      "Bienvenue dans l'univers des thèmes. Choisissez vos centres d'intérêt et lancez-vous dans cette aventure !",
      "Votre premier diaporama IA est en route. Restez connectés !",
      "Préparez-vous pour un voyage en diaporama. Le départ est imminent...",
      "Prêt pour une nouvelle festivité visuelle ? Le diaporama va débuter sous peu...",
      "Accrochez-vous ! Prochain arrêt : le fantastique périple du diaporama...",
      "Dépêchez-vous ! Fermez les yeux et attendez l'arrivée du diaporama surprise...",
      "Le monde du diaporama est sur le point de se dévoiler devant vous, restez à l'affût...",
      "S'il vous plaît, faites preuve de patience, le rêve du diaporama est sur le point de se concrétiser...",
    ],
    directory: [
      "Retrouvez tout ce dont vous avez besoin sur la page annuaire !",
      "La page annuaire est votre précieux allié en navigation, elle vous permet de trouver facilement ce que vous cherchez !",
      "La page annuaire offre une gamme complète de services de navigation, vous permettant de trouver rapidement vos destinations !",
      "Vous ne savez pas où aller ? Trouvez inspiration et orientation sur la page annuaire !",
    ],
    Content: [
      "En attendant... la prochaine diapositive sera aussi chatoyante qu'un arc-en-ciel !",
      "Wow ! La prochaine diapositive éclatera comme un feu d'artifice, vous laissant sans voix !",
      "Soyez patients, la prochaine diapositive sera aussi merveilleuse que l'attente d'un arc-en-ciel de rêve !",
      "Ressentez la magie de l'attente ! La prochaine diapositive illuminera vos yeux !",
      "Restez à l'écoute ! La prochaine diapositive vous réserve une surprise visuelle époustouflante !",
      "Vite ! Tirez les rideaux et préparez-vous à être ébloui par la lumière étincelante de la prochaine diapositive !",
      "Préparez-vous ! La prochaine diapositive apportera une nouvelle explosion de couleurs visuelles !",
      "Votre curiosité est sur le point d'être comblée ! La prochaine diapositive va vous étonner !",
      "En attendant... la prochaine diapositive vous entraînera dans un voyage visuel merveilleux !",
      "Je ne peux plus attendre ! La prochaine diapositive sera aussi excitante qu'une grande fête !",
      "Devinez quelle sera la prochaine diapositive ? La réponse est sur le point d'être dévoilée...",
      "Veuillez attacher votre ceinture, nous sommes sur le point de décoller vers la prochaine aventure...",
      "Le bonheur approche ! La prochaine diapositive fonce vers vous...",
      "Devinez de quelle couleur sera la prochaine diapositive ? La réponse est sur le point d'être révélée...",
      "Wow ! La prochaine diapositive vous réserve des surprises inattendues...",
      "Envie d'essayer ? Le prochain slide va satisfaire votre curiosité...",
      "En attendant... le prochain slide va vous apporter joie et surprises...",
      "En attendant... tout comme attendre une délicieuse tasse de café, la prochaine diapositive ravira votre humeur !",
      "Fermez les yeux, comptez jusqu'à trois, la prochaine diapositive vous réservera des surprises ! 1... 2... 3...",
      "Dans l'aventure ! Attendre le prochain toboggan est aussi excitant que découvrir un trésor !",
      "Êtes-vous prêt ? La prochaine diapositive vous emmènera dans une merveilleuse aventure !",
    ],
    Comprehensive: [
      "Progressivement, découvrez l'immensité du plaisir qui s'offre à vous !",
      "Des thèmes aux annuaires, puis aux pages de contenu, chaque étape est une exploration enrichissante !",
      "Partons ensemble pour un voyage merveilleux, laissant notre empreinte dans ce monde passionnant !",
      "Sur ce site étonnant, découvrons-en davantage ensemble !",
    ],
    Unpurchased: [
      "Envie d'essayer ? La prochaine diapositive vous réserve un véritable festin visuel. Rejoignez-nous !",
      "Plus qu'une simple transaction, c'est un art de vivre ! Cliquez pour acheter et laissez libre cours à votre humeur !",
      "Ici, vous n'achetez pas seulement des produits, mais aussi du bonheur à profusion !",
      "Rejoignez-nous en tant que membre et démarrez un nouveau chapitre de vie joyeuse !",
      "Cliquez pour acheter et transformez chaque journée en une aventure pleine de surprises et de plaisir !",
      "L'acte d'achat est bien plus qu'une simple action, c'est une manière de savourer la vie !",
      "Saisissez l'opportunité, choisissez les produits qui vous plaisent et donnez de la couleur à votre vie !",
      "L'acte d'achat est une aventure merveilleuse. Embarquons ensemble dans ce voyage !",
      "Cliquez pour acheter, offrez-vous une surprise et du bonheur !",
      "L'achat est une expression, choisissons ensemble avec le cœur !",
    ],
  },
};
